// Load PDP rollover imagery only when a customer can use it.
(() => {
  const prepare = async (media) => {
    if (media.dataset.rolloverLoading || media.querySelector('.j-product-rollover')) return;
    const template = media.querySelector('.j-product-rollover-template');
    const source = template?.content.querySelector('.j-product-rollover');
    if (!source) return;
    media.dataset.rolloverLoading = 'true';
    const alternate = source.cloneNode(true);
    media.append(alternate);
    try {
      await alternate.decode();
      if (alternate.naturalWidth) media.classList.add('j-rollover-ready');
    } catch (_) {
      alternate.remove();
      delete media.dataset.rolloverLoading;
    }
  };

  const mediaFor = (target) => target.closest?.('.product__media') || target.closest?.('.product__media-item')?.querySelector('.product__media');

  // Delegation survives Dawn replacing gallery nodes after a color selection.
  document.addEventListener('pointerover', (event) => {
    const media = mediaFor(event.target);
    if (!media || media.contains(event.relatedTarget)) return;
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) prepare(media);
  });
  document.addEventListener('focusin', (event) => {
    const media = mediaFor(event.target);
    if (media) prepare(media);
  });
})();
